import { render, staticRenderFns } from "./OrderClient.vue?vue&type=template&id=03aae22e&scoped=true"
import script from "./OrderClient.vue?vue&type=script&lang=js"
export * from "./OrderClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aae22e",
  null
  
)

export default component.exports